import { useQuery } from "@tanstack/react-query";
import queryString from 'query-string';
import { apiRoutes, fetchJsonInternal, DeferredAggregate } from "@/src/services";

export function useBlacklistIp() {
    const set = async (clientIp: string, timeout = 2 * 60 * 60) => {
        const resp = await fetchJsonInternal(`${apiRoutes.blackList}`, { method: 'POST', mode: 'cors', body: JSON.stringify({ clientIp, timeout }) })
        console.log(resp)
        return resp;
    }

    const list = async (ips: string[]): Promise<{ ip: string, pttl: number }[]> => {
        const url = queryString.stringifyUrl({ url: `${apiRoutes.blackList}`, query: { ips } },{ arrayFormat: 'index' })
        const resp = await fetchJsonInternal(url, { method: 'GET', mode: 'cors' })
        console.log(resp)
        return resp.json;
    }



    return {
        set,
        list,

    }
}



const blackListIpBurst = new DeferredAggregate<string, number>(500, async (ips) => {
    const url = queryString.stringifyUrl({ url: `${apiRoutes.blackList}`, query: { ips } }, { arrayFormat: 'index' })
    const resp = await fetchJsonInternal(url, { method: 'GET', mode: 'cors' })
    console.log(ips, resp)
    return resp.json;
})


export function useBlIpTTL(ip: string) {
    const { data, isLoading } = useQuery({ queryKey: ["bl-ip-pttl", ip], queryFn: async () => ip ? await blackListIpBurst.requestOne(ip) : null });

    return { ttl: data, isLoading }
}

